import { useEffect, useState } from "react";
import BannerBg from "../../images/construction-2.jpg";
import AngleR from "../../images/icons/angleR.svg";
import { fetchData } from "../../api";





export default function Banner() {

    const [projectContents, setProjectContents] = useState(null);
    useEffect(() => {
        fetchData("our-project-contents", true).then(data => setProjectContents(data?.[0]));
    }, []);

    if (!projectContents) return null;


    return (
        <main className="pb-20 max-sm:pb-0">
            <div className="relative w-full  before:bg-[#000]/50 before:backdrop-blur-[0px] before:absolute before:left-0 before:top-0 before:w-full before:h-full max-sm:h-[360px]">
                <img src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${projectContents.BannerImage?.url}`} className="w-full h-full lg:max-h-[800px] object-cover" />
                <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-20 max-sm:w-full">
                    <h1 className="text-white mb-6 max-sm:text-center">{projectContents?.BannerTitle}</h1>
                    <ul className="flex items-center justify-center gap-5 text-white">
                        <li className="flex items-center gap-3"><a href={projectContents?.HomeBtnUrl} className="font-semibold text-white hover:text-[#286766] transition-colors">{projectContents?.HomeBtnTxt}</a> <img src={AngleR} className="h-3" /></li>
                        <li><a href={projectContents?.PageUrl} className="font-semibold text-white hover:text-[#286766] transition-colors">{projectContents?.PageName}</a></li>
                    </ul>
                </div>
            </div>
        </main>
    );
}